import React from 'react';
import AdminTreeEntity from './adminTreeEntity';
import tableStore from '../../store/tableStore';
import { ListGroupItem, Card, ListGroup, Col, Row } from 'react-bootstrap';
// import { getPublishedTrees } from '../../services/publishData';
import loader from '../loader';
import { publishSite, getPublishedTrees } from '../../services/publishData';
import { SearchBox } from '../components/SearchBox';

/**Part of the admin publish, allowing for publishing and viewing of publish state */
export default class AdminTree extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            availableTables: tableStore.publishTables,
            loading: true,
            show: false,
            modalId: undefined,
            searchPhrase: ""
        };
    }
    componentDidMount() {
        // getPublishedTrees();
    }
    componentWillMount() {
        this.setAdminTrees();
        tableStore.on("Publish-Tables", this.setAdminTrees);
    }
    componentWillUnmount() {
        tableStore.removeListener("Publish-Tables", this.setAdminTrees);
    }
    // let tableSto = tableStore.avTables;
    // let tableList;
    /**Gets the publishable trees from API */
    setAdminTrees = () => {
        getPublishedTrees().then((results) => {
            this.setState({
                availableTables: results,
                loading: false
            });
        }).catch((e) => this.setState({ loading: false }));
    };
    /** Updates the object in the list that its been published*/
    changeToPublished = (id) => {
        let updateTree = this.state.availableTables.filter((pTables) => {
            return pTables.id === id;
        });

        const index = this.state.availableTables.indexOf(updateTree[0]);
        updateTree[0].publish = false;
        this.setState((prevState) => ({
            availableTables: prevState.availableTables.splice(index, 1, updateTree[0])
        }));
    };
    /**Publishes site to the API, updates the state in list, then it fires off to view the state */
    publishSite = async (id) => {
        this.changeToPublished(id);
        await publishSite(id);
        setTimeout(() => this.viewSiteState(id), 1250);
    };
    /** handler for viewing the published results data */
    viewSiteState = (id) => {
        this.props.redirect("/publishResults/" + id);
    };
    /**Maps the list and checks if theres any there, 
     * and searchs via the search phrase
     */
    mapTree = () => {
        const { searchPhrase, availableTables } = this.state;
        if (availableTables.length === 0) {
            return (<ListGroupItem >
                <p className="text-center">No tables to publish</p>
            </ListGroupItem>
            );
        } else if (searchPhrase.length > 0) {
            return availableTables.filter((aT) => {
                if (aT.companyName.toLowerCase().includes(searchPhrase.toLowerCase())) {
                    return true;
                }
                return false;
            }).map((table) => {
                // let tableTitle = this.state.availableTables[list].tableName;
                return (
                    <AdminTreeEntity key={table.id} id={table.id} tableTitle={table.name}
                        publish={table.publish} companyName={table.companyName}
                        publishSite={this.publishSite} state={table.state} viewState={this.viewSiteState} />
                );
            });
        } else {
            return availableTables.map((table) => {
                // let tableTitle = this.state.availableTables[list].tableName;
                return (
                    <AdminTreeEntity key={table.id} id={table.id} tableTitle={table.name}
                        publish={table.publish} companyName={table.companyName}
                        publishSite={this.publishSite} state={table.state} viewState={this.viewSiteState} />
                );
            });
        }
    };
    /**Search box on change handler */
    searchBoxHandler = (ev) => {
        const input = ev.target.value;
        this.setState({ searchPhrase: input });
    };
    render() {
        let adminTree;
        if (!this.state.loading) {
            adminTree = (
                <Row>
                    <Col xs={2}></Col>
                    <Col xs={8}>
                        <Card variant="success">
                            <Card.Title>Sites to be published</Card.Title>
                            <ListGroup>
                                {this.mapTree()}

                            </ListGroup>
                        </Card>
                    </Col>

                    <Col xs={2}></Col>

                </Row>
            );
        }
        return (
            <div>
                <SearchBox onChange={this.searchBoxHandler} />
                {this.state.loading ?
                    loader() : adminTree
                }
            </div>
        );
    }
};


// WEBPACK FOOTER //
// ./src/components/admin/adminTree.js